let MenuForAdmin = [

    {
        name: 'addUser',
        route: '/users/add',
        service: 1
     },

     {
        name: 'heshboniotisraelSettings',
        route: '/heshboniotisrael',
        service: 1
     },

     {
        name: 'clientLeads',
        route: '/root-admin/client-leads',
        service: 1
     },

     {
        name: 'supportInbox',
        route: '/root-admin/support',
        service: 1
     },

     {
        name: 'announcements',
        route: '/root-admin/announcements',
        service: 1
     },

     {
        name: 'esign',
        route: '/root-admin/esign',
        service: 1
     },

];

export default MenuForAdmin;